import { useMutation } from "@tanstack/react-query";

import { pauseToggle } from "../api/ventura/adGroup";
import { useConfig } from "./useConfig";

function usePauseToggleAdGroup(adGroupId) {
  const {
    apiHost
  } = useConfig();

  const mutation = useMutation({
    mutationKey: ['pauseToggleAdGroup', adGroupId],
    mutationFn: () => pauseToggle(apiHost, adGroupId),
  })

  return mutation;
}

export default usePauseToggleAdGroup;
